import { LOOKER_GROUP, ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP, CIMANAGER_GROUP } from './canUser-Groups';

const AMSUI_Global = {
  AMSUI_Access: {
    groups: [LOOKER_GROUP, ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP, CIMANAGER_GROUP],
  },
  view_AdminSlideout: {
    groups: [ADMIN_GROUP],
  },
};

export const PERSON_DETAILS = {
  create_Person: {
    groups: [ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP, CIMANAGER_GROUP],
  },
  view_PersonDetails: {
    groups: [LOOKER_GROUP, ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP, CIMANAGER_GROUP],
  },
  edit_PersonDetails: {
    groups: [ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP, CIMANAGER_GROUP],
  },
  view_PersonDetails_SourceSystem: {
    groups: [ADMIN_GROUP],
  },
  view_PersonDetails_AccoutType: {
    groups: [ADMIN_GROUP, CIMANAGER_GROUP],
  },
  edit_PersonDetails_AccoutType: {
    groups: [ADMIN_GROUP, CIMANAGER_GROUP],
  },
  view_PersonDetails_ClientId: {
    groups: [ADMIN_GROUP, CIMANAGER_GROUP],
  },
  edit_PersonDetails_ClientId: {
    groups: [ADMIN_GROUP, CIMANAGER_GROUP],
  },
  edit_PersonDetails_ActiveFlag: {
    groups: [ADMIN_GROUP, TIER2_GROUP],
  },
  remove_PersonAlert: {
    groups: [ADMIN_GROUP, TIER2_GROUP],
  },
};

export const PERSON_SECURITY = {
  view_PersonSecurityContent: {
    groups: [LOOKER_GROUP, ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP],
  },
  edit_PersonSecurityContent: {
    groups: [ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP],
  },
  send_PersonRegistrationEmail: {
    groups: [ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP],
  },
};

export const PERSON_LINKEDACCOUNT = {
  view_PersonLinkedAccountContent: {
    groups: [LOOKER_GROUP, ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP],
  },
  edit_PersonLinkedAccountContent: {
    groups: [LOOKER_GROUP, ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP],
  },
};

export const PERSON_ISSUESRESOLUTIONS = {
  view_PersonIssuesResolutions: {
    groups: [LOOKER_GROUP, ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP],
  },
};

export const PERSON_APPLICATIONACCESS = {
  view_PersonApplicationAccess: {
    groups: [LOOKER_GROUP, ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP],
  },
  edit_PersonApplicationAccess: {
    groups: [ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP],
  },
};

export const PERSON_ORGANDPERMISSIONS = {
  view_PersonOrgAndPermissions: {
    groups: [LOOKER_GROUP, ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP, CIMANAGER_GROUP],
  },
  edit_PersonOrgAndPermissions: {
    groups: [ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP, CIMANAGER_GROUP],
  },
  edit_PersonOrgAndPermissions_Buy: {
    groups: [ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP],
  },
  edit_PersonOrgAndPermissions_Sell: {
    groups: [ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP],
  },
  edit_PersonOrgAndPermissions_Service: {
    groups: [ADMIN_GROUP, CIMANAGER_GROUP],
  },
  edit_PersonOrgAndPermissions_PostSale: {
    groups: [ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP],
  },
  delete_PersonOrgAndPermissions: {
    groups: [ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP, CIMANAGER_GROUP],
  },
  add_PersonOrgAndPermissions: {
    groups: [ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP, CIMANAGER_GROUP],
  },
  copy_PersonOrgAndPermissions: {
    groups: [ADMIN_GROUP, TIER2_GROUP, CIMANAGER_GROUP],
  },
};

export const PERSON_DETAILS_OTHER = {
  add_PersonAlert: {
    groups: [ADMIN_GROUP, TIER2_GROUP],
  },
  view_PersonInformation: {
    groups: [LOOKER_GROUP, ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP, CIMANAGER_GROUP],
  },
  view_PersonContacts: {
    groups: [LOOKER_GROUP, ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP],
  },
  view_PersonRepresentativesPermissions: {
    groups: [LOOKER_GROUP, ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP],
  },
  view_PersonAddAlert: {
    groups: [ADMIN_GROUP, TIER2_GROUP],
  },
  view_PersonRemoveAlert: {
    groups: [ADMIN_GROUP, TIER2_GROUP],
  },
  view_PersonSendRegistrationEmail: {
    groups: [ADMIN_GROUP, TIER2_GROUP],
  },
  view_PersonCopyPermissions: {
    groups: [ADMIN_GROUP],
  },
};
const ORG_DETAILS = {
  view_OrgDetails: {
    groups: [LOOKER_GROUP, ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP, CIMANAGER_GROUP],
  },
  edit_OrgDetails: {
    groups: [ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP, CIMANAGER_GROUP],
  },
  view_OrgIssuesResolutions: {
    groups: [LOOKER_GROUP, ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP],
  },
  view_OrgRepresentativesPermissions: {
    groups: [LOOKER_GROUP, ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP, CIMANAGER_GROUP],
  },
  edit_OrgRepresentativesPermissions: {
    groups: [ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP, CIMANAGER_GROUP],
  },
  view_OrgFranchises: {
    groups: [LOOKER_GROUP, ADMIN_GROUP, EDIT_GROUP, TIER2_GROUP],
  },
  view_OrgAddAlert: {
    groups: [ADMIN_GROUP, TIER2_GROUP],
  },
  view_OrgRemoveAlert: {
    groups: [ADMIN_GROUP, TIER2_GROUP],
  },
  view_OrgAAResync: {
    groups: [ADMIN_GROUP],
  },
  edit_OrgDetails_ActiveFlag: {
    groups: [ADMIN_GROUP, TIER2_GROUP],
  },
  remove_OrgAlert: {
    groups: [ADMIN_GROUP, TIER2_GROUP],
  },
};

export const CANUSER_SCHEMA = { ...AMSUI_Global, ...PERSON_DETAILS, ...PERSON_SECURITY, ...PERSON_LINKEDACCOUNT, ...PERSON_ISSUESRESOLUTIONS, ...PERSON_APPLICATIONACCESS, ...PERSON_ORGANDPERMISSIONS, ...PERSON_DETAILS_OTHER, ...ORG_DETAILS };
